/* 🤖 this file was generated by svg-to-ts */
export const matIconWrongLocation: {
  name: 'wrong-location';
  data: string;
} = {
  name: 'wrong-location',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M18 11v.2c0 2.34-1.95 5.44-6 9.14-4.05-3.7-6-6.79-6-9.14C6 7.57 8.65 5 12 5c.34 0 .68.03 1 .08V3.06c-.33-.04-.66-.06-1-.06-4.2 0-8 3.22-8 8.2 0 3.32 2.67 7.25 8 11.8 5.33-4.55 8-8.48 8-11.8V11h-2z"/><circle cx="12" cy="11" r="2"/><path d="m22.54 2.88-1.42-1.42L19 3.59l-2.12-2.13-1.42 1.42L17.59 5l-2.13 2.12 1.42 1.42L19 6.41l2.12 2.13 1.42-1.42L20.41 5z"/></svg>`
};
